module.exports = "import React from 'react'\nimport './buttons.css'\n\nconst LampSwitchButtons = ({sc}) => (\n  <ul className=\"buttons\">\n    <li> <button className=\"btn btn-primary\" onClick={(e) => {sc.gen('switch-on')}}> Switch On </button> </li>\n    <li> <button className=\"btn btn-secondary\" onClick={(e) => {sc.gen('switch-off')}}> Switch Off </button> </li>\n  </ul>\n);\n\nexport default LampSwitchButtons \n"


//////////////////
// WEBPACK FOOTER
// ./src/examples/two-button-lamp/buttons.js?txt
// module id = 898
// module chunks = 199390669437303